// Declare global gtag function to avoid TypeScript errors
declare global {
    interface Window {
        gtag: (
            command: string,
            action: string,
            params?: {
                [key: string]: any;
            }
        ) => void;
    }
}

// Send a page view to Google Analytics
export const trackPageView = (path: string, title: string) => {
    try {
        if (window.gtag) {
            window.gtag('config', 'G-8EGEXQ98JC', {
                page_path: path,
                page_title: title,
            });
            console.log(`📊 Analytics: Page view tracked - ${title} (${path})`);
        }
    } catch (error) {
        console.error('Analytics error tracking page view:', error);
    }
};

// Track section views
export const trackSectionView = (sectionId: string, sectionTitle: string) => {
    try {
        if (window.gtag) {
            window.gtag('event', 'section_view', {
                section_id: sectionId,
                section_title: sectionTitle,
                event_category: 'section_engagement',
            });
            console.log(`📊 Analytics: Section view tracked - ${sectionTitle} (${sectionId})`);
        }
    } catch (error) {
        console.error('Analytics error tracking section view:', error);
    }
};

// Track node expand/collapse actions
export const trackNodeInteraction = (nodeId: string, nodeTitle: string, action: 'expand' | 'collapse') => {
    try {
        if (window.gtag) {
            window.gtag('event', 'node_interaction', {
                node_id: nodeId,
                node_title: nodeTitle,
                action: action,
                event_category: 'node_engagement',
            });
            console.log(`📊 Analytics: Node ${action} tracked - ${nodeTitle} (${nodeId})`);
        }
    } catch (error) {
        console.error(`Analytics error tracking node ${action}:`, error);
    }
};

// Track external link clicks
export const trackExternalLink = (url: string, linkType: string) => {
    try {
        if (window.gtag) {
            window.gtag('event', 'external_link_click', {
                link_url: url,
                link_type: linkType,
                event_category: 'outbound',
            });
            console.log(`📊 Analytics: External link click tracked - ${linkType} (${url})`);
        }
    } catch (error) {
        console.error('Analytics error tracking external link:', error);
    }
};

// Track Spotify interactions
export const trackSpotifyInteraction = (action: 'play' | 'popup_view' | 'popup_close') => {
    try {
        if (window.gtag) {
            window.gtag('event', 'spotify_interaction', {
                action: action,
                event_category: 'media_engagement',
            });
            console.log(`📊 Analytics: Spotify ${action} tracked`);
        }
    } catch (error) {
        console.error(`Analytics error tracking Spotify ${action}:`, error);
    }
};

// Universal event tracking function for flexibility
export const trackEvent = (
    eventName: string,
    category: string,
    params: Record<string, any> = {}
) => {
    try {
        if (window.gtag) {
            window.gtag('event', eventName, {
                event_category: category,
                ...params,
            });
            console.log(`📊 Analytics: Event tracked - ${eventName} (${category})`);
        }
    } catch (error) {
        console.error('Analytics error tracking event:', error);
    }
};